import { Text } from "@smartsuite/react-ui/lib/components/typography/Text/Text";
import React from "react";
import { hasModeAttrs } from "../../canvas/state/attributes";
import {
  DocumentDesignItem,
  FieldViewModes,
  MultipleSelectItem,
} from "../../canvas/state/types";
import { MultipleSelectModeOptions } from "./constants";
import { StyledSwitchButton } from "../StyledSwitchButton/StyledSwitchButton";

export interface SidebarSelectionConfigMultipleSelectProps {
  selected: MultipleSelectItem;
  onChangeSelected: (modifiedItem: DocumentDesignItem) => void;
}

export const SidebarSelectionConfigMultipleSelect: React.FC<
  SidebarSelectionConfigMultipleSelectProps
> = ({ selected, onChangeSelected }) => {
  return (
    <>
      {hasModeAttrs(selected) && (
        <div>
          <div style={{ marginBottom: 4 }}>
            <Text weight="medium" wrapMode="ellipsis">
              Mode
            </Text>
          </div>
          <StyledSwitchButton
            options={MultipleSelectModeOptions}
            currentValue={selected.mode}
            onChange={(value) =>
              onChangeSelected({
                ...selected,
                mode: value as FieldViewModes,
              })
            }
          />
        </div>
      )}
    </>
  );
};
